var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column py-0",attrs:{"id":"profile-pages"}},[_c('div',{staticClass:"w-100 card py-3 px-lg-4"},[_c('Foyer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }